import Vue from "vue";
import Vuex from "vuex";

import { alert } from "./alert.module";
import { authentication } from "./authentication.module";
import { profile } from "./profile.module";
import appConfig from "../app-config";
import { ui } from "./ui.module";
import { screenFactors } from "./screen-factors.module";
import { numericInputStore } from "./numeric.module";
import { decimalFormattingV1 } from "./v1/decimal-format.module";
import { decimalFormatting } from "./decimal-format.module";
import { defaultUserSettings } from "./default-user-settings.module";
import { defaultCustomerSettings } from "./customer-settings.module";
import { dataContext } from "./data-context.module";
import { transactionTemplate } from "./transaction-template.module";
import { defaultDateSettings } from "./default-date-settings.module";
import { reportPdfPreview } from "./report-pdf-preview.module";
import { roamBinMovement } from "./roam/roam-bin-movement.module";
import { posScans } from "./roam/pos-scans.module";

import { globalFields } from "./global-fields.module";
import { hotKey } from "./hot-key.module";
import { notification } from "./notification.module";
import { gridViewDefinition } from "./grid-view-definition.module";

import { CXSettings } from "./settings.module";

const STORE_KEY = `store_${appConfig.VUE_APP_COOKIE_NAME}`;

Vue.use(Vuex);

let store = new Vuex.Store({
  modules: {
    alert,
    authentication,
    profile,
    ui,
    screenFactors,
    numericInputStore,
    decimalFormattingV1,
    decimalFormatting,
    globalFields,
    defaultUserSettings,
    defaultCustomerSettings,
    dataContext,
    transactionTemplate,
    defaultDateSettings,
    reportPdfPreview,
    hotKey,
    roamBinMovement,
    posScans,
    CXSettings,
    notification,
    gridViewDefinition,
  },
});

store.subscribe((mutation, state) => {
  // Store the state object as a JSON string
  let store = {
    profile: state.profile,
  };

  localStorage.setItem(STORE_KEY, JSON.stringify(store));
});

export { store };
